module.exports = __webpack_public_path__ + "img/pre-register.e88208e4.png";